import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { addListaUFPercurso, removeListaUFPercurso } from "../../../features/manifestoSlice";
import { useState } from "react";
import { JConfirmDelete, MensagemModal } from "../../../components/Components";
import { infPercurso, SelectObjectRemoveInterface } from "../../../interfaces";
import { getUuidV4 } from "../../../utils/utils";

const initialEstadoPercurso: infPercurso = {
    id: 0,
    estado_id: 0,
    uf: ''
}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

export default function UfPercurso() {
    const dispatch = useDispatch();
    const listaUfPercurso = useSelector((state: RootState) => state.manifesto.manifesto.infPercurso);
    const selectUfPercurso = useSelector((state: RootState) => state.manifesto.selectEstados);
    const form = useSelector((state: RootState) => state.manifesto.manifesto);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [formEstado, setFormEstado] = useState<infPercurso>(initialEstadoPercurso);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const validarPreenchimento = () => {
        if (formEstado.estado_id.toString() === '0') {
            alerta('Nenhum estado selecionado.');
            return false;
        }

        if (formEstado.uf.trim() === form.ufini || formEstado.uf.trim() === form.uffim) {
            alerta('UF de percurso não pode ser igual a UF Inicial ou UF Final.');
            return false;
        }

        if (form.infPercurso.find((item) => item.uf === formEstado.uf.trim())) {
            alerta('UF já adicionada');
            return false;
        }

        if (form.infPercurso.length === 25) {
            alerta('Limite máximo de 25 UFs de percurso atingido.');
            return false;
        }

        if (form.infMunCarrega.length === 0) {
            alerta('Informe primeiramente o município de carregamento.');
            return false;
        }
        return true;
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const handleAddUfPercurso = () => {
        if (validarPreenchimento()) {
            dispatch(addListaUFPercurso({
                ...formEstado,
                id: getUuidV4()
            }));
        }
    }

    const handleRemove = (id: number) => {
        dispatch(removeListaUFPercurso(id));
        setShowModal(false);
    }

    return (<>
        <Card className="card-primary card-outline">
            <Card.Header>
                <h6 className="py-0 my-1">UFs de percurso <span className="text-dark">(25 no máximo)</span></h6>
            </Card.Header>
            <Card.Body className="p-3">
                <Row className="g-2">
                    <Col md={8}>
                        <Form.Group className="mb-2">
                            <Form.Select name="uf_percurso" id="uf_percurso"
                                onChange={(e: any) => {
                                    setFormEstado({
                                        ...formEstado,
                                        estado_id: parseInt(e.target.value),
                                        uf: e.target.options[e.target.selectedIndex].text
                                    })
                                }}
                            >
                                {selectUfPercurso.map((estado) => (
                                    <option key={estado.id} value={estado.id}>
                                    {estado.uf === "" ? estado.name : estado.uf}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={'auto'}>
                        <Form.Group className="mb-2">
                            <Button variant="primary" onClick={handleAddUfPercurso}>
                                <FontAwesomeIcon icon={faPlus} /> Adicionar
                            </Button>
                        </Form.Group>
                    </Col>

                </Row>
                <Row>
                    <Col md>
                        <Table striped bordered hover size="sm" responsive="sm">
                            <thead className="table-light">
                                <tr>
                                    <th className="text-center" style={{ width: '2.5rem' }}>#</th>
                                    <th>UF</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listaUfPercurso.map((estado: infPercurso) => (
                                    <tr key={estado.id}>
                                        <td className="text-center">
                                            <a href="#" className="text-danger"
                                                onClick={() => handleOpenModal({ id: estado.id, title: estado.uf })}
                                            >
                                                <i className="fas fa-trash"></i>
                                            </a>
                                        </td>
                                        <td>
                                            {estado.uf}
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Card.Body>
        </Card>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemove}
            selectedObject={selected.title}
            id={selected.id}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}